import LenderRepayment from './LenderRepayment';

export { default as LenderDisbursement } from './LenderDisbursement';

export default LenderRepayment;
